export const isGoogleUrl = (str: string) => {
  const googleRegex = new RegExp(
    /^(https?:\/\/)?(www\.)?google\.[a-z]{2,3}(\.[a-z]{2})?\/?$/,
  );
  return googleRegex.test(str);
};
